// extracted by mini-css-extract-plugin
module.exports = {"faqWrapper":"styles_faqWrapper__hyp4I"};